module.exports = __webpack_public_path__ + "static/media/pool400.2519fa59.jpg";